import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './assets/global.scss'
import store from '@/assets/store'

// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Icons zur Library hinzufügen
library.add(faEye, faEyeSlash)

// Vue-Anwendung erstellen
createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon) // Registriere FontAwesome-Komponente global
  .use(router) // Falls Router verwendet wird
  .use(store)
  .mount('#app')
